import PropTypes from 'prop-types';
export default function MenuItems({ item, hide, id }) {
	const googleAnalyticsId = id ? `${id}-${item.label?.toLowerCase()?.replaceAll(/\s+/g, '-')}` : undefined;
	return (
		<>
			{item && <div className="on-boarding__menu-dropdown__menu-item">
				<div className="on-boarding__menu-dropdown__menu-item-contents" id={googleAnalyticsId} role="button" tabIndex={0} onClick={(e) => {
					item?.onClick(e);
					hide();
				}} onKeyDown={(e) => {
					if (e.key === 'Enter' || e.key === ' ') {
						e.preventDefault();
						item?.onClick(e);
						hide();
					}
				}} key={item.label}>
					<div style={{ color: `${item.labelColor}` }} id={googleAnalyticsId}>
						{item.label}
					</div>
				</div>
			</div>}
		</>
	);
}

MenuItems.propTypes = {
	item: PropTypes.shape({
		label: PropTypes.string,
		labelColor: PropTypes.string,
		onClick: PropTypes.func
	}),
	hide: PropTypes.func,
	id: PropTypes.string
};
